import React from 'react'
import { Link } from 'react-router-dom'

const ProductSection = () => {
  return (
    <div className="container-xxl py-5">
    <div className="container">
      <div
        className="text-center mx-auto mb-5 wow fadeInUp"
        data-wow-delay="0.1s"
        style={{
          maxWidth: 500,
          visibility: "visible",
          animationDelay: "0.1s",
          animationName: "fadeInUp"
        }}
      >
        <p className="text-primary text-uppercase mb-2">Our Works</p>
        <h1 className="display-6 mb-0">
          Discover Our Unique And Creative Photoshoot
        </h1>
      </div>
      <div className="row g-3">
        <div
          className="col-lg-3 col-md-6 wow fadeInUp"
          data-wow-delay="0.1s"
          style={{
            visibility: "visible",
            animationDelay: "0.1s",
            animationName: "fadeInUp"
          }}
        >
          <div className="row g-3">
            <div className="col-12">
              <div className="project-item">
                <img className="img-fluid" src="../assets/img/project-5.jpg" alt="" />
                <a
                  className="project-title h5 mb-0"
                  href="../assets/img/project-5.jpg"
                  data-lightbox="project"
                >
                  Memory
                </a>
              </div>
            </div>
            <div className="col-12">
              <div className="project-item">
                <img className="img-fluid" src="../assets/img/project-1.jpg" alt="" />
                <a
                  className="project-title h5 mb-0"
                  href="../assets/img/project-1.jpg"
                  data-lightbox="project"
                >
                  Wedding
                </a>
              </div>
            </div>
          </div>
        </div>
        <div
          className="col-lg-3 col-md-6 wow fadeInUp"
          data-wow-delay="0.3s"
          style={{
            visibility: "visible",
            animationDelay: "0.3s",
            animationName: "fadeInUp"
          }}
        >
          <div className="row g-3">
            <div className="col-12">
              <div className="project-item">
                <img className="img-fluid" src="../assets/img/project-2.jpg" alt="" />
                <a
                  className="project-title h5 mb-0"
                  href="../assets/img/project-2.jpg"
                  data-lightbox="project"
                >
                  Portrait
                </a>
              </div>
            </div>
            <div className="col-12">
              <div className="project-item">
                <img className="img-fluid" src="../assets/img/project-6.jpg" alt="" />
                <a
                  className="project-title h5 mb-0"
                  href="../assets/img/project-6.jpg"
                  data-lightbox="project"
                >
                  Travel
                </a>
              </div>
            </div>
          </div>
        </div>
        <div
          className="col-lg-3 col-md-6 wow fadeInUp"
          data-wow-delay="0.5s"
          style={{
            visibility: "visible",
            animationDelay: "0.5s",
            animationName: "fadeInUp"
          }}
        >
          <div className="row g-3">
            <div className="col-12">
              <div className="project-item">
                <img className="img-fluid" src="../assets/img/project-7.jpg" alt="" />
                <a
                  className="project-title h5 mb-0"
                  href="../assets/img/project-7.jpg"
                  data-lightbox="project"
                >
                  Wedding
                </a>
              </div>
            </div>
            <div className="col-12">
              <div className="project-item">
                <img className="img-fluid" src="../assets/img/project-3.jpg" alt="" />
                <a
                  className="project-title h5 mb-0"
                  href="../assets/img/project-3.jpg"
                  data-lightbox="project"
                >
                  Memory
                </a>
              </div>
            </div>
          </div>
        </div>
        <div
          className="col-lg-3 col-md-6 wow fadeInUp"
          data-wow-delay="0.7s"
          style={{
            visibility: "visible",
            animationDelay: "0.7s",
            animationName: "fadeInUp"
          }}
        >
          <div className="row g-3">
            <div className="col-12">
              <div className="project-item">
                <img className="img-fluid" src="../assets/img/project-4.jpg" alt="" />
                <Link
                  className="project-title h5 mb-0"
                  to="../assets/img/project-4.jpg"
                  data-lightbox="project"
                >
                  Fashion
                </Link>
              </div>
            </div>
            <div className="col-12">
              <div className="project-item">
                <img className="img-fluid" src="../assets/img/project-8.jpg" alt="" />
                <Link
                  className="project-title h5 mb-0"
                  to="../assets/img/project-8.jpg"
                  data-lightbox="project"
                >
                  Portrait
                </Link>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  
  )
}

export default ProductSection
